import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Row, Col, Button } from "react-bootstrap";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import axios from "axios";
import { useSelector } from "react-redux";
import UploadMedia from "../../../components/media/UploadMedia";
import Notification, {showToast} from "../../../../components/common/notification/Notification";
import { useNavigate } from "react-router-dom";
const MAX_DESCRIPTION_LENGTH = 2000;

const AddPostForm = () => {
  const [services, setServices] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [images, setImages] = useState([]);
  const [videos, setVideos] = useState([]);
  const [attachments, setAttachments] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [description, setDescription] = useState("");
  const [characterCount, setCharacterCount] = useState(0);

  const baseUrl = process.env.REACT_APP_BASE_URL;
  const user = useSelector((state) => state.auth.user);
  const token = user?.refreshToken;
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const serviceRes = await axios.get(`${baseUrl}/all/services`);
        setServices(serviceRes.data.services);

        const stateRes = await axios.post(
          `${baseUrl}/admin/states/1`,
          { page_number: 1, page_size: 20, order_by: "ASC" },
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setStates(stateRes.data.states);
      } catch {
        console.error("Error fetching services and states");
      }
    };
    fetchData();
  }, [baseUrl, token]);

  const fetchCities = async (stateId, setFieldValue) => {
    setFieldValue("city", "");
    if (!stateId) {
      setCities([]);
      return;
    }
    try {
      const res = await axios.post(
        `${baseUrl}/admin/cities/${stateId}`,
        { page_number: 1, page_size: 20, order_by: "ASC" },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setCities(res.data.cities || []);
    } catch {
      setCities([]);
    }
  };

  const validationSchema = Yup.object({
    service: Yup.string().required("Service is required"),
    state: Yup.string().required("State is required"),
    city: Yup.string().required("City is required"),
    description: Yup.string()
      .required("Description is required")
      .max(MAX_DESCRIPTION_LENGTH, "Description too long"),
    // You can add media validation if needed
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    console.log("IMAGES STATE AT SUBMIT:", images); 
    console.log("vi STATE AT SUBMIT:", videos); 
    console.log("att STATE AT SUBMIT:", attachments); 
    const imagesToSend = images.map(img => ({
      image_url: img.image_url,
      imagePath: img.imagePath, 
    }));
    const videosToSend = videos.map(video => ({
      url_path: video.image_url,
    }));
    const attachmentsToSend = attachments.map(att => ({
      attachment_url: att.url,
    }));


    const payload = {
      country_name: "India",
      service: values.service,
      state_name: values.state_name,
      city_name: values.city_name,
      description: values.description,
      images: imagesToSend,
      videos: videosToSend,
      attachments: attachmentsToSend,
      property_status_id: 1,
    };
    console.log("payload ", payload)
    setUploading(true);
    try { 
      // const response = await axios.post(`${baseUrl}/all/lead/add`, 
      const response = await axios.post(`${baseUrl}/property/lead/add`, 
        payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log("response") 
      console.log(response.data.lead)
      console.log(response.data.lead.images[0].image_url)
      if (response.data.statusType === "SUCCESS") {
        showToast("Post added successfully", {type: "success"});
        setTimeout(() => {
          navigate("/post");
        }, 3000);
      } else {
        showToast('Failed to submit Post data', { type: 'error' });
      }
    } catch (err) {
      console.error(err);
        showToast('Failed to add Post data', { type: 'error' });
    } finally {
      setUploading(false);
      setSubmitting(false);
    }
  };

  return (
    <Formik
      initialValues={{
        service_id: "",
        service: "",
        state: "",
        state_name: "",
        city: "",
        city_name: "",
        description: "",
      }}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      className=""
    >
      {({ setFieldValue, values, isSubmitting }) => (
        <div className="container" style={{ marginTop: "120px", marginBottom: "50px" }}>
          <Notification />
          <div className="">
              <h2 className="text-primary fw-bold ">
                 Add Post
              </h2>

            <div className="card shadow rounded-4 p-4 bg-light">
              <Form>
                {/* Service / State / City */}
                <Row className="g-4 mb-4">
                  <Col md={4}>
                    <div className="form-group">
                      <label htmlFor="service_id" className="form-label fw-semibold">Service</label>
                      <Field
                        as="select"
                        name="service_id"
                        id="service_id"
                        className="form-select"
                        value={values.service_id}
                        onChange={(e) => {
                          const selectedOption = e.target.selectedOptions[0];
                          const name = selectedOption.getAttribute("data-name");
                          setFieldValue("service_id", e.target.value);
                          setFieldValue("service", name);
                        }}
                      >
                        <option value="">Select a service</option>
                        {services.map((srv) => (
                          <option key={srv.id} value={srv.id} data-name={srv.name}>
                            {srv.name}
                          </option>
                        ))}
                      </Field>
                      <ErrorMessage name="service" component="div" className="text-danger mt-1 small" />
                    </div>
                  </Col>

                  <Col md={4}>
                    <div className="form-group">
                      <label htmlFor="state" className="form-label fw-semibold">State</label>
                      <Field
                        as="select"
                        name="state"
                        id="state"
                        className="form-select"
                        value={values.state}
                        onChange={async (e) => {
                          const selectedOption = e.target.selectedOptions[0];
                          const name = selectedOption.getAttribute("data-name");
                          const stateId = e.target.value;
                          setFieldValue("state", stateId);
                          setFieldValue("state_name", name);
                          await fetchCities(stateId, setFieldValue);
                        }}
                      >
                        <option value="">Select a state</option>
                        {states.map((state) => (
                          <option key={state.id} value={state.id} data-name={state.name}>
                            {state.name}
                          </option>
                        ))}
                      </Field>
                      <ErrorMessage name="state" component="div" className="text-danger mt-1 small" />
                    </div>
                  </Col>

                  <Col md={4}>
                    <div className="form-group">
                      <label htmlFor="city" className="form-label fw-semibold">City</label>
                      <Field
                        as="select"
                        name="city"
                        id="city"
                        className="form-select"
                        value={values.city}
                        onChange={(e) => {
                          const selectedOption = e.target.selectedOptions[0];
                          const name = selectedOption.getAttribute("data-name");
                          setFieldValue("city", e.target.value);
                          setFieldValue("city_name", name);
                        }}
                      >
                        <option value="">Select a city</option>
                        {cities.map((city) => (
                          <option key={city.id} value={city.id} data-name={city.name}>
                            {city.name}
                          </option>
                        ))}
                      </Field>
                      <ErrorMessage name="city" component="div" className="text-danger mt-1 small" />
                    </div>
                  </Col>
                </Row>

                {/* Description */}
                <div className="mb-4">
                  <label htmlFor="description" className="form-label fw-semibold">Description</label>
                  <div className="border rounded-3 overflow-hidden">
                    <ReactQuill
                      theme="snow"
                      className="bg-white"
                      value={description}
                      onChange={(value) => {
                        setDescription(value);
                        setFieldValue("description", value);
                        setCharacterCount(value.length);
                      }}
                    />
                  </div>
                  <div className="d-flex justify-content-between mt-2 small text-muted">
                    <span>{characterCount}/{MAX_DESCRIPTION_LENGTH} characters</span>
                    {characterCount > MAX_DESCRIPTION_LENGTH && (
                      <span className="text-danger">Description too long</span>
                    )}
                  </div>
                  <ErrorMessage name="description" component="div" className="text-danger mt-1 small" />
                </div>

                {/* Upload Media */}
                <div className="mb-4">
                    <UploadMedia
                      images={images}
                      setImages={setImages}
                      videos={videos}
                      setVideos={setVideos}
                      attachments={attachments}
                      setAttachments={setAttachments}
                      label="Upload images, videos, or PDFs"
                    />
                  </div>

                {/* Submit Button */}
                <div className="d-flex justify-content-end mt-4">
                  <Button
                    type="submit"
                    variant="primary"
                    className="px-4 py-2 fw-semibold"
                    disabled={isSubmitting || uploading || characterCount > MAX_DESCRIPTION_LENGTH}
                  >
                    {uploading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2"></span> Posting...
                      </>
                    ) : (
                      "Submit"
                    )}
                  </Button>
                </div>
              </Form>
            </div>
          </div>
        </div>
      )}
    </Formik>


  );
};

export default AddPostForm;